import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = () => {
  return (
    <Helmet>
      <title>Lifeano APP - 文化视听新体验</title>
      <link rel="canonical" href="https://your-domain.com" />
      <meta name="robots" content="index, follow" />
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "MobileApplication",
            "name": "Lifeano",
            "applicationCategory": "EducationalApplication",
            "operatingSystem": "iOS, Android",
            "description": "聚焦文化类音频和视频的移动端产品，通过文化了解世界，通过世界探究自我",
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "CNY"
            }
          }
        `}
      </script>
    </Helmet>
  );
};

export default SEO;